import { TeamMembersRequestStatus } from '__generated__/GQL';

export const Tabs = ['pending', 'closed'] as const;
export type Tab = (typeof Tabs)[number];

export const tabFilters = {
  closed: [
    TeamMembersRequestStatus.Completed,
    TeamMembersRequestStatus.Canceled,
    TeamMembersRequestStatus.Rejected,
  ],
  pending: [
    TeamMembersRequestStatus.Pending,
    TeamMembersRequestStatus.Approved,
    TeamMembersRequestStatus.Processed,
  ],
} satisfies Record<Tab, TeamMembersRequestStatus[]>;
